<template>
    <div class="bg-white flex flex-col lg:flex-row items-start rounded-bl-lg rounded-br-lg">
        <div class="w-full lg:w-6/12">
            <div
                class="flex flex-col lg:py-11 lg:px-6 border-black border-opacity-10"
                :class="mobile ? 'py-4 lg:border-r' : 'p-4 border-r'"
            >
                <span class="block text-lg font-Inter-Bold mb-3">{{ $t('editor.help.title') }}</span>
                <p class="font-Inter-Regular text-xs">
                    {{ $t('editor.help.text') }}
                </p>
            </div>
        </div>
        <div class="w-full lg:w-6/12">
            <div class="flex flex-col lg:py-11 lg:px-6" :class="mobile ? 'py-4' : 'p-4'">
                <span class="block text-lg font-Inter-Bold mb-3">{{
                    mobile ? $t('editor.help.order_details') : $t('editor.help.guide')
                }}</span>
                <p class="font-Inter-Regular text-xs">
                    {{ $t('editor.help.guide_text') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
// Help box under the editor preview (desktop) or the order form (`mobile`).
export default {
    name: 'EditorHelp',
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
